export * from '~/utils/function.c'

// export const functions = functions